import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Form from './Form';
import Mode from './Mode';
import { withBlank } from '../utils';

var useStyles = makeStyles(function (theme) {
  return {
    container: {
      width: '100%',
      margin: theme.spacing(1, 0),
      padding: 20
    },
    subContainer: {
      width: '100%',
      margin: theme.spacing(2, 0)
    },
    divider: {
      borderRight: '1px solid ' + theme.palette.divider
    },
    disclaimerContainer: {
      padding: theme.spacing(0, 1)
    },
    disclaimer: {
      backgroundColor: R.path(['palette', 'tertiary', 'dark'])(theme) || theme.palette.grey[100],
      padding: theme.spacing(1, 2),
      width: '100%',
      height: '100%'
    }
  };
});

var Share = function Share(_ref) {
  var changeIsMessageOpen = _ref.changeIsMessageOpen,
      changeMode = _ref.changeMode,
      changeMail = _ref.changeMail,
      hasError = _ref.hasError,
      isMessageOpen = _ref.isMessageOpen,
      isSharing = _ref.isSharing,
      mail = _ref.mail,
      mode = _ref.mode,
      modes = _ref.modes,
      share = _ref.share,
      labels = _ref.labels;

  var classes = useStyles();
  return React.createElement(
    Grid,
    { 'data-testid': 'share-test-id', container: true, className: classes.container },
    React.createElement(
      Grid,
      { item: true, xs: 12 },
      React.createElement(Mode, { changeMode: changeMode, modes: modes, mode: mode, title: R.prop('title')(labels) })
    ),
    React.createElement(
      Grid,
      { container: true, className: classes.subContainer },
      React.createElement(
        Grid,
        { item: true, xs: 12, md: 6, className: classes.divider },
        React.createElement(Form, {
          changeMail: changeMail,
          changeIsMessageOpen: changeIsMessageOpen,
          hasError: hasError,
          isMessageOpen: isMessageOpen,
          isSharing: isSharing,
          mail: mail,
          share: share,
          labels: labels
        })
      ),
      React.createElement(
        Grid,
        { item: true, xs: 12, md: 6, className: classes.disclaimerContainer },
        React.createElement(
          Paper,
          { className: classes.disclaimer },
          R.prop('disclaimer')(labels)
        )
      )
    )
  );
};

Share.propTypes = process.env.NODE_ENV !== "production" ? {
  changeIsMessageOpen: PropTypes.func,
  changeMode: PropTypes.func,
  changeMail: PropTypes.func,
  hasError: PropTypes.bool,
  isMessageOpen: PropTypes.bool,
  isSharing: PropTypes.bool,
  mail: PropTypes.string,
  mode: PropTypes.string,
  modes: PropTypes.array,
  share: PropTypes.func,
  labels: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    disclaimer: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    submit: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    email: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    successTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    successMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    errorTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  })
} : {};

export default withBlank(function (_ref2) {
  var isBlank = _ref2.isBlank;
  return { isBlank: isBlank };
})(Share);